import React from "react";
import { Link } from "react-router-dom";

const SideBar = () => {
    return(
        <aside className="dashboard-sidebar">
          <ul className="sidebar-menu">
            <li className="nav-item">
              <Link to={`/signup`} aria-current="page" className="active">
                <svg className="bi">
                  <use xlinkHref="#house-fill" />
                </svg>
                Registration
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to={`/login`}
                className="nav-link d-flex align-items-center gap-2 active"
                aria-current="page"
              >
                <svg className="bi">
                  <use xlinkHref="#house-fill" />
                </svg>
                Login
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to={`/dashboard`}
                className="nav-link d-flex align-items-center gap-2 active"
                aria-current="page"
              >
                <svg className="bi">
                  <use xlinkHref="#house-fill" />
                </svg>
                Help
              </Link>
            </li>
          </ul>
        </aside>
    )
}

export default SideBar;